import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import logo from '../assets/phoenix dental care.png';

const Footer = () => {
  return (
    <footer className="bg-phoenix-black text-phoenix-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img src={logo} alt="Phoenix Dental Logo" className="h-10 w-auto mb-4" />
            <p className="text-phoenix-gray">Your trusted partner for exceptional dental care.</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">Home</a></li>
              <li><a href="#about" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">About</a></li>
              <li><a href="#services" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">Services</a></li>
              <li><a href="#testimonials" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">Contact</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="flex items-center gap-2 mb-2">
              <FaPhone className="text-phoenix-gold" />
              <a href="tel:+919949042692" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">
                +91 9949042692
              </a>
            </div>
            <div className="flex items-center gap-2 mb-2">
              <FaMapMarkerAlt className="text-phoenix-gold" />
              <p className="text-phoenix-gray">Madhurawada, Visakhapatnam</p>
            </div>
            <p className="text-phoenix-gray">info@phoenixdental.com</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">
                <FaFacebook className="w-6 h-6" />
              </a>
              <a href="#" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">
                <FaTwitter className="w-6 h-6" />
              </a>
              <a href="#" className="text-phoenix-gray hover:text-phoenix-gold transition-colors">
                <FaInstagram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p className="text-phoenix-gray">&copy; 2025 Phoenix Dental. All rights reserved. Designed by <a href="https://jnitdigitalmarketing.com" target="_blank" rel="noopener noreferrer" className="text-phoenix-gold hover:underline">JN IT SOLUTIONS</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
